import React from "react";
import FTUTooltipsWizard from "./FTUTooltipsWizard";
import FTUTooltipsWizardContextProvider from "./FTUTooltipsWizardContextProvider";

const FTUTooltipsWizardWrapper = () => {
  return (
    <FTUTooltipsWizardContextProvider>
      <FTUTooltipsWizard />
    </FTUTooltipsWizardContextProvider>
  );
};

export default FTUTooltipsWizardWrapper;
